<template>
    <div v-loading="mixinLoading">
        <Query ref="query" key="campaignQuery" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal
        ref="refcustomizeModal"
        :customList="assignObj"
        :selectList="selectList"
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <!-- 表格 -->
        <div class="com-table-view-apple">
            <div class="operation-box" id="operation-box">
                <div class="operation-left">
                    <el-button type="primary" size="mini" v-if="pageFuncNames.includes('add_campaign')" :loading="addLoading" @click="handleClickAdd">Create New Campaign</el-button>
                    <el-divider direction="vertical" v-if="pageFuncNames.includes('add_campaign')"></el-divider>
                    <el-menu
                        v-if="isHasBatchAuth"
                        class="apple-cascader"
                        mode="horizontal"
                        @select="(val)=>handleCommand(val, '')">
                        <el-submenu index="1" :popper-append-to-body="false">
                            <template slot="title"><span>Batch Edit</span></template>
                            <el-menu-item index="1" v-if="!isHasAuth('edit_campaign_status')" :disabled="isEmptySelection"><span class="text-color-success">Switch - Run</span></el-menu-item>
                            <el-menu-item class="err-menu-item" index="2" v-if="!isHasAuth('edit_campaign_status')" :disabled="isEmptySelection"><span class="text-color-error">Switch - Pause</span></el-menu-item>
                            <!-- <el-menu-item index="3" disabled><span style="color: #333;">复制</span></el-menu-item> -->
                            <el-menu-item index="4" v-if="!isHasAuth('edit_daily_budget')" :disabled="isEmptySelection"><span style="color: #333;">Daily Budget</span></el-menu-item>
                            <el-menu-item class="err-menu-item" index="5" v-if="!isHasAuth('del')" :disabled="isEmptySelection"><span class="text-color-error">Delete</span></el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <span style="padding-left: 8px;" v-if="multipleSelection.length>0">{{multipleSelection.length}} Items Selected</span>

                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">Custom Columns</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">Export</el-button>
                </div>
            </div>

            <div style="min-height: 200px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    ref="multipleTable"
                    :row-key="getRowKey"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @cell-mouse-enter="handleCellMouseEnter"
                    @selection-change="handleSelectionChange"
                    @sort-change="handlesortchange"
                    v-loading="!mixinLoading && loading"
                    header-row-class-name="jt_sticky"
                >
                    <!--复选框）-->
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                        :selectable="selectable"
                        >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :min-width="column.width"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                        v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div v-if="scope.$index===0" class="">
                                <span v-if="column.name==firstColumnName">Total</span>
                                <div v-else-if="scope.row[column.name]">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>
                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>
                                <span v-else>-</span>
                            </div>
                            <div :class="{ lineheightmax: getshowTip(column.name) }"
                            v-else-if="column.field_type=='1' && column.name=='campaign_name'"
                            class="text-color-primary pointer"
                            @click="handleClickCampaignName(scope.row)">
                                {{scope.row[column.name]}}
                            </div>

                            <el-switch
                                v-else-if="column.field_type=='1' && column.name=='campaign_status'"
                                v-model="scope.row.campaign_status"
                                :disabled="isHasAuth('edit_campaign_status') || !selectable(scope.row) || scope.row['campaign_status_disabled']"
                                active-value="ENABLED"
                                inactive-value="PAUSED"
                                @change="(val)=>handleSwith(scope.row, column.name, val)">
                            </el-switch>

                            <div class="table_operate" v-else-if="column.field_type=='1' && column.name=='operate'">
                                <el-button type="text" :disabled="!pageFuncNames.includes('edit')|| !selectable(scope.row)" @click="handleEdit(scope.row)">Edit</el-button>
                                <el-button type="text" @click="handledrawer(scope.$index)" class="mr10">Details</el-button>
                                <el-dropdown @command="(val)=>handleCommand(val, scope.$index)" v-if="!isHasAuth('del')">
                                    <span class="el-dropdown-link">
                                        <div style="transform: rotate(90deg);cursor: pointer;">
                                            <i class="el-icon-more"></i>
                                        </div>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="6" :disabled="scope.row['delbtn_status_disabled'] || !selectable(scope.row)" :style="{cursor: (scope.row['delbtn_status_disabled'] || !selectable(scope.row)) ? 'no-drop' : 'pointer'}">
                                            <span class="menude" :class="{menuDisabled: (scope.row['delbtn_status_disabled'] || !selectable(scope.row)) ? true : false}">Delete</span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <!-- <el-popconfirm
                                    title="这是一段内容确定删除吗？"
                                    >
                                    <el-button slot="reference">Delete</el-button>
                                </el-popconfirm> -->
                            </div>

                            <div class="custom_input" :class="[active == scope.$index ? 'active' : '']"
                            ref="myParagraph"
                            v-else-if="column.field_type=='1' && column.name=='daily_budget'">
                                <el-input
                                    v-if="active != scope.$index"
                                    size="mini"
                                    class="custom_input_el"
                                    :value="formatNumberWithCommas(Number(scope.row.daily_budget))"
                                    @focus="handleFocus(scope.row.daily_budget, scope.$index, 'list')"
                                    readonly
                                    :disabled="isHasAuth('edit_daily_budget') || !selectable(scope.row)"
                                    ref="myParagraphread"
                                    >
                                    <template slot="append" v-if="active != scope.$index">{{scope.row.daily_budget_currency}}</template>
                                </el-input>
                                <el-input
                                    v-if="(active == scope.$index)"
                                    size="mini"
                                    placeholder="Product: Enter"
                                    class="custom_input_el"
                                    v-model="scope.row.daily_budget"
                                    @blur="handleBlur(scope.$index)"
                                    @input="(value)=>handleInput(value, scope.row)"
                                    :disabled="scope.row['edit_daily_budget_disabled'] || !selectable(scope.row)"
                                    ref="myParagraphread"
                                    >
                                    <template slot="append" v-if="active != scope.$index">{{scope.row.daily_budget_currency}}</template>
                                </el-input>
                                <div class="custom_input_btn" v-if="active == scope.$index">
                                    <button class="custom_input_success" :class="{'btn-disabled': scope.row['edit_daily_budget_disabled']}" :disabled="scope.row['edit_daily_budget_disabled']" @click="handleOK(scope.row, 'daily_budget', 'list')"><i class="el-icon-check"></i></button>
                                    <button class="custom_input_close" :class="{'btn-disabled': scope.row['edit_daily_budget_disabled']}" :disabled="scope.row['edit_daily_budget_disabled']" @click="handleClose(scope.row, scope.$index, 'list')"><i class="el-icon-close"></i></button>
                                </div>
                            </div>

                            <div
                            v-else-if="column.field_type=='1' && column.name=='campaign_display_status'"
                            :class="getStatusColor(scope.row['campaign_display_status'], scope.row['campaign_serving_state_reasons'])">
                                {{scope.row['campaign_serving_state_reasons']}}
                            </div>

                            <div v-else-if="column.field_type=='1' && column.name=='start_end_time'">
                                <p>Start:{{scope.row['start_time']}}</p>
                                <p>End:{{scope.row['end_time']}}</p>
                            </div>

                            <div v-else-if="column.field_type=='2'">
                                <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                    <div class="column_name text-nowrap">
                                        {{ getcurrency(scope.row, column.name)['name'] }}
                                    </div>
                                    <div class="column_currency">
                                        {{ getcurrency(scope.row, column.name)['currency'] }}
                                    </div>

                                </div>
                                <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                            </div>

                            <div :class="{ lineheightmax: getshowTip(column.name) }" v-else><span ref="paragraphs">{{scope.row[column.name]}}</span></div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30, 50, 100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <el-drawer
                title="嘿嘿"
                :visible.sync="drawer"
                :with-header="false"
                :destroy-on-close="true"
                :before-close="beforeClose"
                size="45%">
                <div class="custom_drawer" v-if="drawer">
                    <div class="title">
                        <span style="font-size: 16px; font-weight: bold;">Details</span>
                        <el-button size="mini" type="primary" :disabled="!pageFuncNames.includes('edit')|| !selectable(tableData[activeIndex])" @click="toEditPage">Edit</el-button>
                    </div>
                    <div class="drawer_list">
                        <h4>Basic Information</h4>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'campaign_name')">
                            <div>Campaign Name：</div>
                            <div>
                                <div class="custom_input" :class="[infoactive ? 'active' : '']" ref="myInfoParagraphName">
                                    <el-input
                                        v-if="!infoactive"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 10}"
                                        size="mini"
                                        class="custom_input_el"
                                        :style="{minHeight: '48px'}"
                                        :value="tableData[activeIndex]['campaign_name']"
                                        @focus="handleInfoFocus(tableData[activeIndex]['campaign_name'])"
                                        readonly
                                        :disabled="isHasAuth('edit_campaign_name') || !selectable(tableData[activeIndex])"
                                        ref="myInfonameParagraphread"
                                        >
                                    </el-input>
                                    <el-input
                                        v-if="infoactive"
                                        size="mini"
                                        type="textarea"
                                        :autosize="{ minRows: 2, maxRows: 10}"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        :style="{minHeight: '48px'}"
                                        v-model="tableData[activeIndex]['campaign_name']"
                                        @blur="handleInfoBlur"
                                        :disabled="isHasAuth('edit_campaign_name') || !selectable(tableData[activeIndex])"
                                        ref="myInfonameParagraphread"
                                        >
                                    </el-input>
                                    <div class="custom_input_btn" v-if="!isHasAuth('edit_campaign_name') && infoactive">
                                        <button class="custom_input_success" :class="{'btn-disabled':btnloading}" :disabled="btnloading"  @click="handleInfoOK(tableData[activeIndex], activeIndex)"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled':btnloading}" :disabled="btnloading" @click="handleInfoClose(tableData[activeIndex], activeIndex)"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'campaign_id')">
                            <div>Campaign ID：</div>
                            <div>{{tableData[activeIndex]['campaign_id']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'campaign_status')">
                            <div>Switch：</div>
                            <div>
                                <el-switch
                                    v-model="tableData[activeIndex]['campaign_status']"
                                    :disabled="isHasAuth('edit_campaign_status') || !selectable(tableData[activeIndex]) || tableData[activeIndex]['campaign_status_disabled']"
                                    active-value="ENABLED"
                                    inactive-value="PAUSED"
                                    @change="(val)=>handleSwith(tableData[activeIndex], 'campaign_status', val)">
                                </el-switch>
                            </div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'app_info')">
                            <div>Product：</div>
                            <div>{{tableData[activeIndex]['app_info']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'supply_source')">
                            <div>Placement：</div>
                            <div>{{tableData[activeIndex]['supply_source']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'countries_or_regions')">
                            <div>Countries or Regions：</div>
                            <div>{{tableData[activeIndex]['countries_or_regions']}}</div>
                        </div>
                        <div class="drawer_item" v-if="getShowInfoItem(assignObjqx, 'daily_budget')">
                            <div>Daily Budget:</div>
                            <div>
                                <div :style="{width: '45%'}" class="custom_input center" :class="[infoysactive ? 'active' : '']" ref="myInfoParagraphMoney">
                                    <el-input
                                        v-if="!infoysactive"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(tableData[activeIndex]['daily_budget']))"
                                        @focus="handleFocusInfo(tableData[activeIndex]['daily_budget'], activeIndex, 'info')"
                                        readonly
                                        :disabled="isHasAuth('edit_daily_budget') || !selectable(tableData[activeIndex])"
                                        ref="myInfoParagraphread"
                                        >
                                        <template slot="append" v-if="!infoysactive">{{tableData[activeIndex]['daily_budget_currency']}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="infoysactive"
                                        size="mini"
                                        placeholder="Please Enter"
                                        class="custom_input_el"
                                        v-model="tableData[activeIndex]['daily_budget']"
                                        @blur="handleBlur(activeIndex)"
                                        @input="(value)=>handleInput(value, tableData[activeIndex])"
                                        :disabled="isHasAuth('edit_daily_budget') || !selectable(tableData[activeIndex])"
                                        maxlength="142740000"
                                        ref="myInfoParagraphread"
                                        >
                                        <template slot="append" v-if="!infoysactive">{{tableData[activeIndex]['daily_budget_currency']}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="infoysactive">
                                        <button class="custom_input_success" :class="{'btn-disabled': tableData[activeIndex]['edit_daily_budget_disabled']}" :disabled="tableData[activeIndex]['edit_daily_budget_disabled']" @click="handleOK(tableData[activeIndex], 'daily_budget', 'info')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': tableData[activeIndex]['edit_daily_budget_disabled']}" @click="handleClose(tableData[activeIndex], activeIndex, 'info')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drawer_list" v-if="getShowInfoItem(assignObjqx, 'start_end_time')">
                        <h4>Campaign Duration</h4>
                        <div class="drawer_item">
                            <div>Campaign Start Date：</div>
                            <div>{{tableData[activeIndex]['start_time']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Campaign End Date：</div>
                            <div>{{tableData[activeIndex]['end_time']}}</div>
                        </div>
                    </div>
                    <div class="drawer_list">
                        <h4>Billing Information</h4>
                        <div class="drawer_item">
                            <div>Billing Options：</div>
                            <div>{{tableData[activeIndex]['loc_invoice_type']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Advertiser or Product：</div>
                            <div>{{tableData[activeIndex]['client_name']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Order Number：</div>
                            <div>{{tableData[activeIndex]['order_number']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Primary Contact Name：</div>
                            <div>{{tableData[activeIndex]['buyer_name']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Primary Contact Email：</div>
                            <div>{{tableData[activeIndex]['buyer_email']}}</div>
                        </div>
                        <div class="drawer_item">
                            <div>Billing Contact Email：</div>
                            <div>{{tableData[activeIndex]['billing_contact_email']}}</div>
                        </div>
                    </div>
                </div>
            </el-drawer>

            <el-dialog
                :title="null"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                :close-on-press-escape=false
                :show-close=false
                :destroy-on-close=true
                width="450px"
                custom-class="apple-dialog-err">
                <div>
                    <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                    <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
                </div>
            </el-dialog>

            <BatchBudgetModal ref="batchBudgetModal" :list="multipleSelection" @update="getListBody(props_params)" />
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Query from "../components/query.vue";
    import CustomizeModal from '../modal/customizeModal';
    import API from '@/api/marketManage/apple/index-en';
    import BatchBudgetModal from '../campaign/modal/batchBudgetModal';
    import { cloneDeep, debounce } from 'lodash'
    import {
        handleDocumentNoctiyClick,
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html,
        get_flag_mul_err_html
    } from "../components/getFlagHtml.js";
    const other_Table_columns_no_sort = ['plan_name_start_date', 'creation_time', 'start_end_time'] //需要独立处理的排序
    import { EarlyWarnMixin } from '@/views/marketingManagement/mixins'
    export default {
        name: "CampaignIndex",
        mixins: [ EarlyWarnMixin({language: "EN", page: 'campaign' }) ],
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        components: {
            Query,
            CustomizeModal,
            BatchBudgetModal,
        },
        data() {
            return {
                pageName:'apple_promotion_manage_campaign',
                value:true,
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                btnloading: false,  //每日预算按钮loading
                active: -1, // 每日预算点击
                drawer: false, //抽屉
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                selectList: [],
                multipleSelection: [],
                columns: [],
                tableData:[],
                cloneTableData: [],
                customBtnLoading: false, //自定义列按钮loading
                activeIndex: -1, //选中的详情条数
                cacha_money: '',  //缓存每日预算
                cacha_name: '', //缓存广告系列名称
                infoValue: false, // 详情开关
                infoactive: false, // 详情广告名称 显示输入与否
                infoysactive: false, //详情每日预算  显示与否
                infoName: '', // 广告系列名称
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                options: [
                    {
                        value: '1',
                        label: 'Switch - Run',
                        children: [
                            {
                                value: 'all',
                                label: 'Select All',
                            }
                        ]
                    },
                    {
                        value: '2',
                        label: 'Switch - Pause',
                    },
                    {
                        value: '3',
                        label: 'Copy',
                    },
                    {
                        value: '4',
                        label: 'Daily Budget',
                    },
                    {
                        value: '5',
                        label: 'Delete',
                    }
                ],
                notifyarr: [],
                dialogVisible: false,   //各种错误提示
                dialogBoo: true,   // 是否失败
                dialogType: 1,   //1单个处理 2多个处理
                dialogTypeTitle: 'Batch switch-on Request successful, processing…', //显示提示头
                dialogTypeBody: '1000027869，Processing, please wait', //显示提示头
                mulerrIds: '',
                mulErr:'',
                mulexc: '',
                cachaHeader: 1,
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                exportLoading:false,
                addLoading:false,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),
            allFilterList(){
                let dimensions = cloneDeep(this.pageDimension)
                /* 需要过滤掉[操作]列 */
                return dimensions.filter(item=>item['config'] && item.name!='operate').map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: 'Basic Information',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            assignObjqx() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    return item['name'];
                })
                let qx_res = []
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            qx_res.push(itemc['name'])
                        })
                    }
                    return item;
                })
                return [...res_dime,...qx_res]
            },
            getappledialogerr() {
                if(this.mulErr != '' && this.mulexc != '') {
                    return 1
                }else if(this.mulErr != '' || this.mulexc != ''){
                    return 2
                }else{
                    return 3
                }
            },
            isEmptySelection(){
                return this.multipleSelection.length<=0;
            },
            isHasAdGroupAction(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name).includes('apple_adgroup');
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
            isHasBatchAuth(){
                let funcNames = this.pageFuncNames||[];
                return funcNames.includes('edit_campaign_status')||funcNames.includes('edit_daily_budget')||funcNames.includes('del');
            },
            firstColumnName(){
                let column = this.columns[0]||{};
                return column.name||'-';
            }
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        mounted() {
            this.getEventTip()
            // 处理表格内部blur事件
            document.addEventListener('click', this.handleDocumentClick);
            // 处理详情内部的blur事件
            document.addEventListener('click', this.handleDocumentClickInfoName);
            document.addEventListener('click', this.handleDocumentClickInfoMoney);

            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })

        },
        beforeDestroy() {
            // 处理表格内部blur事件
            // 在组件销毁前移除全局点击事件监听器
            document.removeEventListener('click', this.handleDocumentClick);
            document.removeEventListener('click', this.handleDocumentClickInfoName);
            document.removeEventListener('click', this.handleDocumentClickInfoMoney);

        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }
                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                // this.props_params = {...params, range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn}
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                this.getListBody(this.props_params,isClear)
            },
            getRowKey(row) {
                return row['campaign_id']
            },
            getShowInfoItem(arr, name) {
                if(Array.isArray(arr) && arr.length != 0) {
                    let isshow = arr.some(item=> item== name)
                    return isshow
                }else{
                    return false
                }
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // campaign_name 广告系列 countries_or_regions 国家跟地区 campaign_display_status 状态 company_name  客户 org_name广告系列组 app_info 产品 bloc_name集团
                const showTip = ['org_name','countries_or_regions', 'campaign_display_status', 'company_name', 'app_info', 'bloc_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            getParagraphHeights() {
                this.$nextTick(() => {
                    const paragraphs = this.$refs.paragraphs;

                    // 遍历每个p标签并获取高度
                    this.paragraphHeights = paragraphs.map(paragraph => paragraph.clientHeight);

                    // 打印高度数组
                    console.log('Paragraph Heights:', this.paragraphHeights);
                });
            },
            beforeClose(done) {
                this.tableData[this.activeIndex]['daily_budget'] = this.tableData[this.activeIndex]['cache_daily_budget']
                this.tableData[this.activeIndex]['campaign_name'] = this.tableData[this.activeIndex]['cache_campaign_name']
                done();
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            // 获取列表头
            getListHead(callback) {
                this.$refs.query.setSubmitLoading(true);
                this.loading = true
                this.columns.length = 0
                API.getCustomField({field_type: 'apple_promotion_manage_campaign'}).then(res => {
                    let resData = res.data || []
                    this.selectList = resData
                    const width140 = ['org_id', 'account_name_start_date', 'campaign_id', 'campaign_display_status', 'operate']
                    const width110 = ['account_yy_type', 'yy_name', 'campaign_status', 'supply_source']
                    this.columns = resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = (item['display_name']||'').length
                            /* 曝光均价：单独设置宽度250 */
                            // item['width'] = item.name=='imp_price'?250:((nums * 12)) + 60
                            if(item.name=='imp_price' || item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        if(item.name == 'campaign_status') {
                            item['align'] = 'center'
                        }
                        if(item.name == 'daily_budget') {
                            item['align'] = 'right'
                        }
                        return item
                    })
                    this.cachaHeader = 2
                    callback && callback(resData)
                }, err=>{
                    this.loading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            setListQueryData(){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
            },
            //  获取列表体
            getListBody(params,isClear) {
                    this.loading = true
                    this.$refs.query.setSubmitLoading(true);
                    if(isClear){
                        this.$refs.query.setClearLoading(true);
                    }

                    this.setListQueryData();
                    API.getCampaignList(params).then(res => {
                        this.loading = false
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                        let resData = res.data
                        let table_list = resData.list && resData.list.map(item=>{
                            item['campaign_status_disabled'] = false  // 开关 disabled  默认关
                            item['delbtn_status_disabled'] = false  // 删除按钮 disabled  默认关
                            item['edit_daily_budget_disabled'] = false  //每日预算 默认关

                            item['cache_campaign_status'] = item['campaign_status']
                            item['cache_campaign_display_status'] = item['campaign_display_status']
                            item['cache_campaign_serving_state_reasons'] = item['campaign_serving_state_reasons']

                            item['cache_campaign_name'] = item['campaign_name']

                            if(item['daily_budget'] == '-') {
                                item['daily_budget'] = ''

                            }
                            if(item['daily_budget'] == '-') {
                                item['cache_daily_budget'] = ''
                            }else{
                                item['cache_daily_budget'] = item['daily_budget']
                            }
                            return item
                        })

                        this.tableData = [resData.total||{}].concat(table_list);
                        this.totalCnt = resData.totalCnt

                        this.active = -1
                    }, err=>{
                        if(err.code =='403'){
                            this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return
                        }
                        this.loading = false
                        this.$message.error(err.info)
                        this.active = -1
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                    })
            },
            // 获取状态颜色
            getStatusColor(val, reason) {
                let texts = reason !='-' ? 'pointer' : ''
                if(val == 'RUNNING') {
                    return `lineheightmax text-color-success apple_states ${texts}`
                }else if(val == 'ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else if(val == 'CAMPAIGN_ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else{
                    return `lineheightmax apple_states ${texts}`
                }
            },
            // 设置不可以选择
            selectable(row, index) {
                if(index===0) return false;
                if(row['campaign_display_status'] == 'DELETED') {
                    return false
                }else{
                    return true
                }
            },
            // 千分位处理
            formatNumberWithCommas(number) {
                // Check if the input is a valid number
                if (isNaN(number) || number == '') {
                    return "-";
                }
                let formattedNumber = number.toLocaleString();

                if (formattedNumber.indexOf('.') !== -1) {
                    formattedNumber = parseFloat(number).toFixed(2);
                }
                return formattedNumber;
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_campaign',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields

                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params)
                    })
                }, (err) => {
                    this.customBtnLoading = false
                    console.log('error', err);
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            // 多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 表格鼠标滑过
            handleCellMouseEnter(row, column, cell, event) {

            },
            handleEdit(row){
                console.log('handleEdit',row);
                this.$store.commit('apple/SET_CREATE_TYPE','editOrg');
                this.$store.commit('apple/SET_EDIT_INFO',{
                    org_id:row.org_id,
                    campaign_id:row.campaign_id,
                });

                this.$emit('click-add','edit',{
                    org_id:row.org_id,
                    campaign_id:row.campaign_id,
                });

            },
            // 批量操作
            /**
             * 开 1  ENABLED
             * 关 2  PAUSED
             * 复制 3
             * 每日预算 4
             * 删除 5
             */
            handleCommand(el, index) {
                let selected_list_id = this.multipleSelection.map(item=>item.campaign_id)
                console.log(el, selected_list_id)
                // 开
                if(el == 1) {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'campaign_status', 'ENABLED')
                        return
                    }

                    this.handleSwithMul('campaign_status', selected_list_id, 'ENABLED', 'Batch switch-on request successful, processing...')
                }
                // 关
                if(el == 2) {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'campaign_status', 'PAUSED',)
                        return
                    }
                    this.handleSwithMul('campaign_status', selected_list_id, 'PAUSED', 'Batch switch-off request successful, processing...')
                }
                // 复制
                // if(el == 3) {
                //     API.editCampaignStatus({campaign_id: [], status: 'PAUSED'})
                // }
                // 每日预算
                if(el == 4) {

                    let checkedList = this.multipleSelection;
                    if(checkedList.length<=0) return this.$message.error('Please select the data that needs to be operated');
                    let currencyText = checkedList[0].daily_budget_currency;
                    if(checkedList.every(item=>item.daily_budget_currency==currencyText)){
                        this.showBatchBudgetModal();
                    }else{
                        return this.$message.error('The selected campaigns include multiple currency units; you need to select series with the same unit for batch modification');
                    }
                }
                // 批量删除
                if(el == 5) {
                    this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            if(selected_list_id.length == 1) {
                                let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == selected_list_id[0])
                                this.fetchdel('del', this.tableData[selectIndex]['campaign_id'], selectIndex)
                                return
                            }
                            this.fetchdelmul('del', selected_list_id)
                        }).catch(() => {
                    });

                }
                // 单独删除
                if(el == 6) {
                    this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            this.fetchdel('del', this.tableData[index]['campaign_id'], index)
                        }).catch(() => {
                    });

                }
            },
            handleCascader(value) {
                console.log('value', value)
            },
            showBatchBudgetModal(){
                this.$refs.batchBudgetModal.showModal();
            },
            // 开关  单个
            handleSwith(rows, select_name, status) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(rows['campaign_id'])
                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                rows['campaign_status_disabled'] = true

                let fetchparams = {campaign_id: [rows['campaign_id']], status: status, current_name: current_name}
                this.fetchSwith(fetchparams, current_name, select_name)

            },
            fetchSwith(fetchparams, old_current_name, select_name) {
                API.editCampaignStatus(fetchparams).then(res=>{
                    let resultData = res.data
                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = resultData['id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['campaign_status'] = resultData['status']
                        this.tableData[selectIndex]['campaign_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['campaign_serving_state_reasons'] = resultData['serving_state_reasons']

                        this.tableData[selectIndex]['cache_campaign_status'] = resultData['status']
                        this.tableData[selectIndex]['cache_campaign_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['cache_campaign_serving_state_reasons'] = resultData['serving_state_reasons']
                        this.tableData[selectIndex]['campaign_status_disabled'] = false
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }

                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }

                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 还原表格状态
                    let select_id = fetchparams['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        // this.tableData[selectIndex]['campaign_status'] = resultData['status']
                        // this.tableData[selectIndex]['campaign_display_status'] = resultData['display_status']
                        // this.tableData[selectIndex]['campaign_serving_state_reasons'] = resultData['serving_state_reasons']
                        this.tableData[selectIndex]['campaign_status'] = this.tableData[selectIndex]['cache_campaign_status']
                        this.tableData[selectIndex]['campaign_display_status'] = this.tableData[selectIndex]['cache_campaign_display_status']
                        this.tableData[selectIndex]['campaign_serving_state_reasons'] = this.tableData[selectIndex]['cache_campaign_serving_state_reasons']
                        this.tableData[selectIndex]['campaign_status_disabled'] = false
                    }
                })
            },
            // 开关  多个
            handleSwithMul(select_name , prop_id, status, title) {

                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= title

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let fetchparams = {campaign_id: prop_id, status: status, current_name: current_name}

                API.editCampaignStatus(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)

                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }

                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , fetchparams['current_name'], errIds)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${fetchparams['current_name']}_close`,
                        value: current_tip,
                    });
                    // 多个失败表格状态不动
                    this.getListBody(this.props_params)
                })
            },
            // 删除  单个
            fetchdel(select_name, prop_id, sel_index) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(prop_id)

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });
                this.tableData[sel_index]['delbtn_status_disabled'] = true
                let fetchparams = {campaign_id: [prop_id], current_name: current_name}
                this.axiosdel(fetchparams, current_name, select_name)
            },
            axiosdel(fetchparams, old_current_name, select_name) {
                API.delCampaign(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)
                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    let select_id = fetchparams['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['delbtn_status_disabled'] = false
                    }
                    this.active = -1
                })
            },
            // 删除 多个
            fetchdelmul(select_name, prop_id) {
                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= 'Batch delete request successful, processing…'

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                API.delCampaign({campaign_id: prop_id, current_name: current_name}).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)

                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name, errIds)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    this.getListBody(this.props_params)
                })
            },

            // 处理表格内部blur事件
            handleDocumentClick(event) {
                if(this.active != -1 && this.drawer == false) {
                    const targetAreas = this.$refs.myParagraph
                    let isareas = targetAreas.some(item=> item.contains(event.target))
                    const isOutsideClick = targetAreas && !isareas
                    if (isOutsideClick) {
                        // 如果点击事件发生在指定区域外，隐藏指定区域
                        this.tableData[this.active]['daily_budget'] = this.tableData[this.active]['cache_daily_budget']
                        this.active = -1
                        const targetInput = this.$refs.myParagraphread
                        if(Array.isArray(targetInput) && targetInput.length != 0) {
                            targetInput.forEach(item=>{
                                item.blur()
                            })
                        }else{
                            targetInput.blur()
                        }
                    }
                }

            },
            handleDocumentClickInfoMoney(event) {
                if(this.drawer == true) {
                    const targetAreas = this.$refs.myInfoParagraphMoney
                    const isOutsideClick = targetAreas && !targetAreas.contains(event.target)
                    if (isOutsideClick) {
                        const targetInput = this.$refs.myInfoParagraphread
                        targetInput && targetInput.blur()
                        this.tableData[this.activeIndex]['daily_budget'] = this.tableData[this.activeIndex]['cache_daily_budget']
                        this.infoysactive = false
                    }
                }
            },
            handleDocumentClickInfoName(event) {
                if(this.drawer == true) {
                    const targetAreas = this.$refs.myInfoParagraphName
                    const isOutsideClick = targetAreas && !targetAreas.contains(event.target)
                    if (isOutsideClick) {
                        const targetInput = this.$refs.myInfonameParagraphread
                        targetInput && targetInput.blur()
                        this.tableData[this.activeIndex]['campaign_name'] = this.tableData[this.activeIndex]['cache_campaign_name']
                        this.infoactive = false
                    }
                }

            },
            // 每日预算 focus
            handleFocus(val, index, type) {
                console.log(index)
                if(this.isHasAuth('edit_daily_budget')) return
                if(this.active != -1){
                    this.tableData[this.active]['daily_budget'] = this.tableData[this.active]['cache_daily_budget']
                }
                this.active = index

            },
            handleFocusInfo(val, index, type) {
                if(this.isHasAuth('edit_daily_budget')) return
                // this.cacha_money = val
                this.infoysactive = true
            },
            // 每日预算 blur
            handleBlur(index) {
                // this.active = -1
            },
            // 修改每日预算
            handleOK(values, select_name, type) {
                console.log(values, select_name)
                if(values['daily_budget'] == '' || values['daily_budget'] == 0) {
                    this.$message.error('Must be greater than or equal to 0.01');
                    return
                }
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(values['campaign_id'])

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                values['edit_daily_budget_disabled'] = true

                let fetchparams = {data:[{campaign_id:values['campaign_id'], daily_budget: Number(values['daily_budget'])}] , current_name: current_name}
                this.fetchDailyBudget(fetchparams, current_name, select_name)
            },
            fetchDailyBudget(fetchparams, old_current_name, select_name) {
                API.editCampaignDailyBudget(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['data'][0]['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['daily_budget'] = Number(resultData['daily_budget'])
                        this.tableData[selectIndex]['cache_daily_budget'] = Number(resultData['daily_budget'])
                        // this.active = -1
                        this.infoysactive = false
                        this.tableData[selectIndex]['edit_daily_budget_disabled'] = false
                        if(this.active == selectIndex){
                            this.active = -1
                        }
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['data'][0]['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['daily_budget'] = this.tableData[selectIndex]['cache_daily_budget']
                        this.tableData[selectIndex]['edit_daily_budget_disabled'] = false
                        // this.active = -1
                        this.infoysactive = false
                        if(this.active == selectIndex){
                            this.active = -1
                        }

                    }
                })
            },
            handleClose(values, index, type) {
                if(type == 'list') {
                    this.active = -1;
                }else{
                    this.infoysactive = false
                }
                values['daily_budget'] = this.tableData[index]['cache_daily_budget']
            },
            // 只可以输入数字
            handleInput(val, rows, limit = 2) {
                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                rows.daily_budget = rval
            },
            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportCampaignList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    this.$message.error(err.info||'Request Error');
                })
            },
            // 排序
            handlesortchange({column, prop, order}) {
                //ascending 升   descending 降
                console.log(column, prop, order)
                let order_type = order == 'ascending' ? 'asc' : 'desc'
                this.props_params['order_by'] = prop
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        },
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span',
                                style: this.getEarlyWarnThem(column)
                            }, values.column.label),
                        content_html,
                        this.renderEarlyWarnIcon(h, column)
                    ])

                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            searchList(){
                let routeParams = this.$route.params||{};
                let $query = this.$refs.query;
                console.log('searchList',routeParams,this.zone,this.rangeTime,$query.getQueryData());
            },
            // 详情
            handledrawer(val) {
                this.activeIndex = val
                // this.cacha_money = this.tableData[val]['daily_budget']
                // this.cacha_name = this.tableData[val]['campaign_name']
                this.drawer = true
            },
            // 详情开关
            handleInfoSwith() {

            },
            // 详情输入框 focus
            handleInfoFocus(val) {
                // this.cacha_name = val
                this.infoactive = true
                // this.$refs.myInfoParagraph.focus()
            },
            // 详情输入框 blur
            handleInfoBlur() {
                // this.infoactive = false
            },
            // 详情输入框 校验
            handleInfoChange(value) {
                let reg = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|[^\x00-\x7F\xA0-\uD7FF\uE000-\uFFFF]/;
                let otherReg = /^[^[\];{}"<>]*$/;
                if(reg.test(value)){
                    this.$message.error('Cannot input [];{}"<> or emojis');
                    return true
                }else if(!otherReg.test(value)) {
                    this.$message.error('Cannot input [];{}"<> or emojis');
                    return true
                }else if(value == ''){
                    this.$message.error('Cannot be empty');
                    return true
                }else if(value.length > 200){
                    this.$message.error('Cannot be empty, up to 200 characters');
                    return true
                }else{
                    return false
                }
            },

            // 修改系列名称
            handleInfoOK(values, index) {
                let ispu = this.handleInfoChange(values['campaign_name'])
                if(ispu) return
                this.btnloading = true
                let currency_time = new Date().valueOf()
                let current_name = `editname_${currency_time}`

                API.editCampaignName({campaign_id: values['campaign_id'], campaign_name: values['campaign_name']}).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                     // 赋予表格状态
                    let select_id = values['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.btnloading = false
                        this.infoactive = false
                        this.tableData[selectIndex]['cache_campaign_name'] = resultData.name
                        this.tableData[selectIndex]['campaign_name'] = resultData.name
                    }

                },err=>{
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = values['campaign_id']
                    let selectIndex = this.tableData.findIndex((element) => element['campaign_id'] == select_id)
                    if(selectIndex != -1) {
                        this.btnloading = false
                        this.infoactive = false
                        this.tableData[selectIndex]['campaign_name'] = this.tableData[selectIndex]['cache_campaign_name']
                    }
                })
            },
            handleInfoClose(values, index) {
                this.infoactive = false
                values['campaign_name'] = this.tableData[index]['cache_campaign_name']
            },
            getSearchList(isClear){
                if(!isClear){
                    this.props_params.range_time = this.rangeTime.join('/');
                    this.props_params.time_zone = this.zone;
                    this.getListBody(this.props_params);
                }else{
                    this.$refs.query.resetForm();
                }
            },
            handleClickCampaignName(row){
                console.log('handleClickCampaignName',row);
                if(this.isHasAdGroupAction){
                    this.$emit('to-page','apple_adgroup',{
                        campaign_id:[row.campaign_id],
                        campaign_name:[row.campaign_name],
                    });

                    // this.$router.push({
                    //     name:'apple_adgroup',
                    //     query:{
                    //         campaign_id:[row.campaign_id],
                    //         campaign_name:[row.campaign_name],
                    //     },
                    //     params:{
                    //         range:this.rangeTime,
                    //         zone:this.zone,
                    //     },
                    // });
                }else{
                    this.$message.error('No page permission, unable to drill down or redirect. Please apply for permissions if needed.');
                }
            },
            handleClickAdd(){
                console.log('handleClickAdd');
                this.addLoading = true;
                API.check_campaign_add_campaign().then(()=>{
                    this.addLoading = false;
                    this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                    this.$store.commit('apple/SUBMIT_URL_NAME','campaign_add_campaign');
                    this.$emit('click-add','create','');
                },err=>{
                    this.addLoading = false;
                    this.$message.error(err.info||'Request Error');
                });
            },
            toEditPage(){
                console.log('toEditPage',this.tableData[this.activeIndex]);
                this.drawer = false;
                this.handleEdit(this.tableData[this.activeIndex]);

            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/apple_sd.scss";
    #operation-box ::v-deep{
        .apple-cascader.el-menu--horizontal{
            border-bottom: none;
            .el-submenu__title,.el-menu-item{
                font-size: 12px;
                border-bottom: none;
                padding: 0 15px!important;
            }
            &>.el-submenu .el-submenu__title{
                font-size: 12px;
                padding: 0 15px!important;
                color: #409eff;
                background: #ecf5ff;
                border: solid 1px #b3d8ff;
                height: 28px;
                line-height: 26px;
                border-radius: 3px;
                border-bottom-color: #b3d8ff!important;
                .el-submenu__icon-arrow{
                    color: #409eff;
                    display: inline-block!important;
                }
                &:hover{
                    background: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    .el-submenu__icon-arrow{
                        color: #fff;
                    }
                }
            }

            .el-menu-item:hover{
                background-color:#ecf5ff;
            }
            .err-menu-item:hover{
                background-color:#fef0f0;
            }
        }
    }



.custom_input{
    .el-input__inner{
        padding: 0 8px;
    }
    .el-input-group__append{
        padding: 0 8px;
    }
}


.render-header-div{
    display: flex;
    align-items: center;
    .render-header-span{
        display: inline-block;
    }
}
// .apple-dialog{
//     width: 100%;
//     .apple-dialog-body{
//         .a_b_title{
//             display: flex;
//             align-items: center;
//             .el-icon-success{
//                 color: #52c41a;
//                 font-size: 32px;
//             }
//             .el-icon-error{
//                 color: #ff0000;
//                 font-size: 32px;
//             }
//             h5{
//                 font-size: 16px;
//                 padding-left: 8px;
//             }
//         }
//         .a_b_body{
//             padding-left: 40px;
//         }
//         .a_b_footer{
//             text-align: right;
//         }
//     }
// }
</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }
    .table_operate{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span{
            cursor: pointer;
        }
    }
    .custom_drawer{
        padding: 0 8px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e8eaec;
            padding: 8px 4px;
        }
        .drawer_list{
            padding: 8px 0;
            h4{
                font-size: 16px;
                margin-bottom: 8px;
                padding-left: 14px;
            }
            .drawer_item{
                display:flex;
                align-items: center;
                margin-bottom: 16px;
                &>div{
                    &:first-child {
                        width: 160px;
                        flex: 0 0 160px;
                        padding-left: 32px;
                        padding-right: 8px;
                        color: #7F7F7F;
                        font-size: 14px;
                    }
                    &:last-child {
                        flex: auto
                    }
                }
            }
        }
        .custom_input{
            align-items: flex-end;
            margin: 0;
            padding: 0;
            &.center{
                align-items: center;
            }
        }
    }
    .menude{
        color: #ff0000;
        cursor: pointer;
        &.menuDisabled{
            color: #a19999;
            cursor: no-drop;
        }
    }

    .nodata{
        min-height: 300px;
    }


</style>


